/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
import React, { Component } from 'react';
import {
  InlineLoading,
  FormGroup,
  TextArea,
  AccordionItem,
  Tile,
  DatePickerSkeleton,
  Accordion,
  ComposedModal,
  ModalHeader,
  ModalBody,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
  TableCell,
  Form,
  FormLabel,
  Loading,
  TextInput,
  ModalFooter,
  Tab,
  Tabs,
  TabsSkeleton,
  Toggle, //RITM0937302
} from 'carbon-components-react';
import {
  Information16,
  CheckmarkOutline16,
  Send16,
  Error16,
} from '@carbon/icons-react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import View16 from '@carbon/icons-react/lib/view/16';
import Save16 from '@carbon/icons-react/lib/save/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Attachment16 from '@carbon/icons-react/lib/attachment/16';

import Delete16 from '@carbon/icons-react/lib/delete/16';
import { v4 as uuid } from 'uuid';
import SimpleReactValidator from 'simple-react-validator';
import FileUpload from '../../common/FileUpload';
import { ConfirmAlertCustom } from '../../../helpers/ConfirmAlertCustom';
import { FindGHRSEmployer } from '../../common/FindGHRSEmployer';
import { NoRecordsPlaceholder } from '../../../helpers/jsonschemaform/DataTableExtention';
import FindSaipemCompilers from '../../common/FindSaipemCompilers';
import {
  getError,
  sizeFormat,
  getSuccess,
  apioperation,
  entitiesLabels,
  DateFormat,
  STATUS,
} from '../../../helpers/Constants';
import DateTimePicker from '../../../helpers/DateTimePicker';
import { me, api, inspection } from '../../../helpers/api/api';
import PageBreadCrumb, { StatusTag } from '../../../helpers/PageBreadCrumb';

import { showNotification } from '../../../helpers/notification/BaseNotification';
import { InspectionInformation } from './common/InspectionInformation';
import { InspectionNotification } from './InspectionNotification';
import { InspectionPersonnel } from './InspectionPersonnel';

import CheckListQuestionAnswer from './common/CheckListQuestionAnswer';
import CheckListRequirement from './common/CheckListRequirement';
import {
  IsEnabled,
  IsEditable,
  CanExecuteAction,
  IsInRole,
} from '../../../helpers/authorization/Policies';
import { WFActionModal } from '../../common/WFActionModal';
import { HistoryTable } from '../../../helpers/HistoryTable';
import { AppContext } from '../../../helpers/context/AppContext';
import { Online, Offline } from '../../common/OnLineOffLine';
import FileDownLoadButton from '../../common/FileDownloadButton';
import InspectionRepository from '../../../helpers/api/InspectionRepository';
import InspectionDistribution from './InspectionDistribution';

export class InspectionReport extends Component {
  carModelProps = () => ({
    dueDate: null,
    id: null,
    carOwner: {},
    idOwner: null,
    idAnswer: null,
    detailsOfInefficiency: null,
  });

  ownerModelprops = () => ({
    fullname: null,
    email: null,
  });

  constructor(props) {
    super(props);
    this.validationsNotifications = new SimpleReactValidator();
    this.validationsCar = new SimpleReactValidator();
    this.updateState = this.updateState.bind(this);
    this.updateStateActivity = this.updateStateActivity.bind(this);
    this.state = {
      inspectionkey: this.props.match.params, // //No GOOD
      inspectionModel: {},

      carModel: {
        ...this.carModelProps(),
      },
      ownerModel: {
        ...this.ownerModelprops(),
      },
      idOwnerSaipem: null, // idEmployer: null,  //guid
      ownerSaipem: {
        // employer: {
        id: null, // guid
        // name: '',
        // surname: '',
        // email: '',
      },
      isDeleting: false,
      isLoadtemplate: false,
      downloading: false,
      notificationForm: {},
      isSendNotifications: false,
      isSaveNotifiication: false,
      activities: [],
      documents: [],
      inspector: [],
      isOpenModalGHRS: false, // //No GOOD
      // /Status Action
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      approvalStartDate: null,
      approvalEndDate: null,
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvers: [],
      idToDelete: null,
      isSaveCar: false,
      selectedData: [],
      approverRole: '',
      withApprover: true,
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      // HT
      isHistoryModalOpen: false,
      editingDisabled: this.state?.inspectionModel?.inspectionReport
        ? !IsEditable(
            'Inspection',
            'Reporting',
            this.context.user,
            this.state?.inspectionModel?.inspectionReport.status.id,
            'All',
            this.state?.inspectionModel?.inspectionReport
          )
        : false,
        isDisabledSend: true,
    };
    this.onAdditionalNoteChange = this.onAdditionalNoteChange.bind(this);
    this.onReportSummaryChange = this.onReportSummaryChange.bind(this);
    this.onUpload = this.onUpload.bind(this);
    this.onUploadAnswer = this.onUploadAnswer.bind(this);
    this.downloadAttachment = this.downloadAttachment.bind(this);
    this.handleChangeGHRSModal = this.handleChangeGHRSModal.bind(this);
    this.setEmployer = this.setEmployer.bind(this);
    this.saveCar = this.saveCar.bind(this);
    this.newCheckListRequirementAdded = this.newCheckListRequirementAdded.bind(this);
    this.getCanEditResource = this.getCanEditResource.bind(this);
    this.onDetailsOfInefficiencyChange = this.onDetailsOfInefficiencyChange.bind(this);
    this.getAttachmentAnswerUrl = this.getAttachmentAnswerUrl.bind(this);
    this.getAttachmentAnswerName = this.getAttachmentAnswerName.bind(this);
    this.getAttachmentUrl = this.getAttachmentUrl.bind(this);
    this.getAttachmentName = this.getAttachmentName.bind(this);
      this.updateMainInformation = this.updateMainInformation.bind(this);
      this.mainInfoDateChange = this.mainInfoDateChange.bind(this);

      //RITM0560302 
      this.mainInfoProjectAreaChange = this.mainInfoProjectAreaChange.bind(this);

  }

    componentDidMount() {
    this.getInspectionEdit(this.state.inspectionkey.id);
    this.getInspectorsInspection(this.state.inspectionkey.id);
    }

    getInspectionEdit(id) {
            this.setState({
                isEditModal: true,
                isOpenModalInspection: true,
                tabsLoading: true,
            });
        inspection
            .get(id)
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        inspectionModel: response.data,
                        notificationForm: response.data.inspectionReport.notificationForm,
                        activities: response.data.inspectionReport.notificationForm.activities, // //No GOOD
                        documents: response.data.inspectionReport.notificationForm.documents,
                        inspector: response.data.inspectors,
                        idPlan: response.data.id,
                        isLoadingElement: false,
                        editingDisabled: !IsEditable(
                            'Inspection',
                            'Reporting',
                            this.context.user,
                            response.data.inspectionReport.status.id,
                            'All',
                            response.data.inspectionReport
                        ),
                    });
                }
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.GET));
            })
            .finally(() => {
                this.setState(
                    {
                        isLoadingElement: false,
                        tabsLoading: false,
                    },
                    () => {
                        // this.getSelectedEntityRoles();
                    }
                );
            });
    }

  setEmployer = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state };
      statusCopy.ownerModel.fullname = employer.fullname;
      statusCopy.ownerModel.email = employer.email;
      statusCopy.carModel.carOwner = employer;
      statusCopy.carModel.idOwner = employer.id;
      statusCopy.carModel.owner = employer;
      statusCopy.idOwnerSaipem = null;
      statusCopy.ownerSaipem = null;
      this.setState({ model: statusCopy, mode: 0, owner: employer });
      this.setState(statusCopy);

      this.setState({ isOpenModalGHRS: false });
    }
  };

  setSaipemOwner = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state };
      statusCopy.carModel.carOwner = employer;
      statusCopy.carModel.idOwnerSaipem = employer.id;
      statusCopy.carModel.idOwner = null;
      statusCopy.ownerModel.fullname = employer.fullName;
      statusCopy.ownerModel.email = employer.email;
      statusCopy.ownerSaipem = employer;
      statusCopy.idOwner = null;
      statusCopy.owner = null;

      this.setState({ model: statusCopy, mode: 0, owner: employer });
    }
  };

  showModalCar = (idAnswer, requirement, sectionCode) => {
    const statusCopy = { ...this.state };
    statusCopy.carModel.id = uuid();
    statusCopy.carModel.idInspection = this.state.inspectionkey.id;
    statusCopy.carModel.idInspectionReport = this.state.inspectionModel.idInspectionReport;
    statusCopy.carModel.idAnswer = idAnswer;
    statusCopy.carModel.section = sectionCode;
    statusCopy.carModel.requirement = requirement;
    statusCopy.isOpenModalCar = true;
    statusCopy.carModel.detailsOfInefficiency = '';
    this.setState(statusCopy);
  };

  showModalUpdateCar = (car) => {
    const statusCopy = { ...this.state };
    statusCopy.carModel.id = car.id;
    statusCopy.carModel.idInspection = car.idInspection;
    statusCopy.carModel.idInspectionReport = car.idInspectionReport;
    statusCopy.carModel.idAnswer = car.idAnswer;
    statusCopy.carModel.dueDate = moment(car.dueDate).format('YYYY-MM-DD');
    statusCopy.carModel.detailsOfInefficiency = car.detailsOfInefficiency;
    statusCopy.carModel.section = car.section;
    statusCopy.carModel.requirement = car.requirement;
    statusCopy.carModel.idOwner = car.idOwner;
    statusCopy.carModel.idOwnerSaipem = car.idOwnerSaipem;
    statusCopy.ownerModel.email = car.owner ? car.owner.email : car.ownerSaipem.email;
    statusCopy.ownerModel.fullname = car.owner ? car.owner.name : car.ownerSaipem.name;
    statusCopy.isOpenModalCar = true;
    statusCopy.isUpdateDocument = true;

    this.setState(statusCopy);
  };

  saveCar = () => {
    if (this.validationsCar.allValid()) {
      this.setState({
        isSaveCar: true,
      });
      const car = this.state.carModel;
      if (!this.state.isUpdateDocument) {
        var idInspection = this.state.inspectionkey.id;
        var { idAnswer } = this.state.carModel;
        if (idAnswer == null || idInspection == null) return;
        this.setState({
          carModel: {
            ...this.state.carModel,
            idAnswer,
          },
        });
      }

      const method = this.state.isUpdateDocument
        ? api.put(
            `inspection/${this.state.carModel.idInspection}/answer/${this.state.carModel.idAnswer}/car/${this.state.carModel.id}`,
            this.state.carModel
          )
        : api.post(`inspection/${idInspection}/answer/${idAnswer}/car`, this.state.carModel);

      method
        .then((response) => {
          if (response.status === 200) {
            if (!this.state.isUpdateDocument) {
              car.idStatus = 1;
              if (!car.status) {
                car.status = {
                  id: 1,
                  caManagementName: 'Draft',
                  carManagementName: 'Assigned',
                  carSimplifiedName: 'Opened',
                  name: 'Draft',
                  planningName: 'Draft',
                  reportingName: 'Opened',
                };
              }
            }
            if (car.idOwnerSaipem != null) {
              car.ownerSaipem = car.carOwner;
            }
            InspectionRepository.updateCachedCarList(car);
            if (!this.state.isUpdateDocument) {
              const { answers } = this.state.inspectionModel.inspectionReport.checkList;

              const index = answers.findIndex((qa) => qa.id === idAnswer);

              answers[index].car = response.data.inspectionCar || car;
              this.setState((prevState) => {
                const state = { ...prevState };
                state.inspectionModel.inspectionReport.checkList.answers = answers;
                return state;
              });
              this.closemodalCar();
            } else {
              const { answers } = this.state.inspectionModel.inspectionReport.checkList;

              const index = answers.findIndex((qa) => qa.id === this.state.carModel.idAnswer);

              answers[index].car = response.data;
              this.setState((prevState) => {
                const state = { ...prevState };
                state.inspectionModel.inspectionReport.checkList.answers = answers;
                return state;
              });
              this.closemodalCar();
            }
            this.closemodalCar();
            showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.CAR, apioperation.POST));
          }
        })
        .catch((error) => {
          showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.POST));
        })
        .finally(() => {
          this.closemodalCar();
          this.setState(
            {
              isSaveCar: false,
            },
            () => {
              // this.getSelectedEntityRoles();
            }
          );
        });
    } else {
      this.validationsCar.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,
        `${entitiesLabels.INSPECTION_REPORT} required fields are missing  `
      );

      this.forceUpdate();
    }
  };

  closemodalCar = () => {
    this.setState({
      carModel: {
        ...this.carModelProps(),
      },
      ownerModel: {
        ...this.ownerModelprops(),
      },
      isUpdateDocument: false,
      isOpenModalCar: false,
    });
    this.validationsCar = new SimpleReactValidator();
  };

  showGHRS = () => {
    const statusCopy = { ...this.state };
    statusCopy.isOpenModalGHRS = true;
    this.setState(statusCopy);
  };

  handleChangeGHRSModal() {
    const statusCopy = { ...this.state };
    statusCopy.isOpenModalGHRS = false;
    this.setState(statusCopy);
  }
  handleChangeMode = (m) => {
    this.setState({ mode: m });
  };
  updateStateDPCAR = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy.carModel.dueDate = inputValue;
    this.setState(statusCopy);
  };

  getCanEditResource = () => {
    const canEditResource = this.state.inspectionModel &&
      this.state.inspectionModel.inspectionReport && {
        idCompiler: this.state.inspectionModel.inspectionReport.idCompiler,
      };
    return canEditResource;
  };

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy.inspectionModel.inspectionReport.notificationForm.documents = inputValue;
    statusCopy.documents = inputValue;
    this.setState(statusCopy);
  };

  updateStateActivity = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy.inspectionModel.inspectionReport.notificationForm.activities = inputValue;
    statusCopy.activities = inputValue;
    this.setState(statusCopy);
  };

  updateStateInspectors = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy.inspectionModel.inspectors = inputValue;
    statusCopy.inspector = inputValue;
    this.setState(statusCopy);
  };

  updateCheckList = async () => {
    try {
      this.setState({ isSubmitted: true });
      await api.put('/inspection/checklist', this.state.inspectionModel);
      InspectionRepository.updateCachedInspectionList(this.state.inspectionModel);
      InspectionRepository.updateCachedInspection(this.state.inspectionModel);
      showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.INSPECTION, apioperation.PUT));
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(entitiesLabels.INSPECTION, apioperation.PUT));
    } finally {
      this.setState({ isSubmitted: false });
    }
  };

  showRequirment = () => {
    this.setState({
      isLoadtemplate: true,
    });
  };

  getTemplate = () => {
    const result = [];
    const map = new Map();
    this.state.inspectionModel.inspectionReport.checkList.answers.map((item) => {
      if (!map.has(item.idInspectionCheckListTemplate)) {
        map.set(item.idInspectionCheckListTemplate, true);
        //result.push(item.template);
        result.push({...item.template, active: item.active}); //RITM0937302
      }
    });
    return result;
  };

  //RITM0937302 - Inspection Module Toggle
  toggleActiveTemplateQuestions = (idCheckListTemplate) => {
    const updatedAnswer =this.state.inspectionModel.inspectionReport.checkList.answers.map((answer) => {
      if(answer.idInspectionCheckListTemplate === idCheckListTemplate) return {...answer, active: !answer.active}
      return {...answer}
    })
    const copyOfInspection = {...this.state.inspectionModel}
    copyOfInspection.inspectionReport.checkList.answers = updatedAnswer
    this.setState({ inspectionModel: copyOfInspection })
  }
  //End

  getSections = (idTemplate) => {
    const result = [];
    const map = new Map();
    this.state.inspectionModel.inspectionReport.checkList.answers.map((item) => {
      if (
        item.idInspectionCheckListTemplate === idTemplate &&
        !map.has(item.idInspectionCheckListTemplateSection)
      ) {
        map.set(item.idInspectionCheckListTemplateSection, true);
        result.push(item.section);
      }
    });
    return result.sort((a, b) => a.ranking - b.ranking);
  };

  getQuestionAnswer = (idSection) => {
    const result = [];
    this.state.inspectionModel.inspectionReport.checkList.answers.map((item) => {
      if (
        item.idInspectionCheckListTemplateSection === idSection &&
        item.question &&
        item.requirement == null
      )
        result.push(item);
    });

    var reA = /[^a-zA-Z]/g;
    var reN = /[^0-9]/g;

    return result.sort((a, b) => {
      var aA = a.question.code.toUpperCase().replace(reA, '');
      var bA = b.question.code.toUpperCase().replace(reA, '');
      if (aA === bA) {
        var aN = parseInt(a.question.code.toUpperCase().replace(reN, ''), 10);
        var bN = parseInt(b.question.code.toUpperCase().replace(reN, ''), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    });

    /* return result.sort((a, b) => {
      const codeA = a.question.code.toUpperCase();
      const codeB = b.question.code.toUpperCase();
      return codeA < codeB ? -1 : codeA > codeB ? 1 : 1;
    });*/
  };

  getRequirementAnswer = (idSection) => {
    const result = [];
    this.state.inspectionModel.inspectionReport.checkList.answers.map((item) => {
      if (item.idInspectionCheckListTemplateSection === idSection && item.requirement)
        result.push(item);
    });
    return result.sort((a, b) => {
      const codeA = a.requirement.code.toUpperCase();
      const codeB = b.requirement.code.toUpperCase();
      return codeA < codeB ? -1 : codeA > codeB ? 1 : 0;
    });
  };

  onAnswerChange = (id, answer) => {
    const { answers } = this.state.inspectionModel.inspectionReport.checkList;
    const index = answers.findIndex((qa) => qa.id === id);
    if (answers[index].answer !== answer) answers[index].answer = answer;
    else answers[index].answer = null;
    this.setState((prevState) => {
      const inspectionReportModel = { ...prevState.inspectionModel.inspectionReport };
      inspectionReportModel.checkList.answers = answers;
      return { inspectionReportModel };
    });
  };

  onNoteChange(id, note) {
    note.preventDefault();
    const { answers } = this.state.inspectionModel.inspectionReport.checkList;
    const index = answers.findIndex((qa) => qa.id === id);
    answers[index].notes = note.target.value;
    this.setState((prevState) => {
      const inspectionReportModel = { ...prevState.inspectionModel.inspectionReport };
      inspectionReportModel.checkList.answers = answers;
      return { inspectionReportModel };
    });
  }

    getInspectorsInspection(id) {
            api
                .getAll(`inspection/report/${id}/inspectors`)
                .then((response) => {
                    this.setState({
                        inspectionsinspector: response.data,
                    });
                })
                .catch((error) => {
                    showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.GET));
                })
                .finally(() => {
                    this.setState({
                        isLoadingInspectors: false,
                    });
                });
        }


    updateMainInformation = () => {
        try {
            //if (this.validationsNotifications.allValid()) {
                this.setState({ isSubmitted: true, editingDisabled: true });
                api.put('/inspection/maininformation', this.state.inspectionModel);

                showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.INSPECTION, apioperation.PUT));
            //} else {
            //    this.validationsNotifications.showMessages();
            //    showNotification.warning(
            //        `Warning: ${entitiesLabels.NOTIFICATION} required fields are missing  `
            //    );

            //    this.forceUpdate();
            //}
        } catch (error) {
            showNotification.error(`${entitiesLabels.ERROR}`,getError(entitiesLabels.INSPECTION, apioperation.PUT));
        } finally {
            this.setState({ isSubmitted: false, editingDisabled: false });
        }
    };

    mainInfoDateChange = () => {
        this.setState({ notifKey: Math.random() });
    };

    //RITM0560302
    mainInfoProjectAreaChange = (value) => {
        this.setState({ inspectionModel:{...this.state.inspectionModel, projectArea: value} });
    };

  saveNotificationForm = (notificationform) => {
    this.setState({
      isSaveNotifiication: true,
    });
      this.updateMainInformation();
      const { documents } = this.state;
        const { activities } = this.state;
      const datiForm = {
        id: this.state.inspectionModel.inspectionReport.notificationForm.id,
        distributionList: notificationform.distributionList,
        responsibleEmail: notificationform.responsibleEmail,
        //RITM0960566 - Inspection Report Problem Fix
        sendedOn: this.state.inspectionModel.inspectionReport.notificationForm.sendedOn,
        sendedBy: this.state.inspectionModel.inspectionReport.notificationForm.sendedBy,
        //End
        documents,
        activities,
      };
      api
        .put('/inspection/notification', datiForm)
        .then((response) => {
          if (response.status === 200) {
            showNotification.success(`${entitiesLabels.SUCCESS}`,'Successfully saved');
            InspectionRepository.updateCachedInspectionList(this.state.inspectionModel);
            InspectionRepository.updateCachedInspection(this.state.inspectionModel);
            this.getInspectionEdit(this.state.inspectionkey.id);
          } else {
            showNotification.error(`${entitiesLabels.ERROR}`,
              getError('Unsuccessfully saved', entitiesLabels.INSPECTION, apioperation.POST)
            );
          }
        })
        .catch((error) => {
          showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.POST));
        })
        .finally(() => {
          this.setState({
            isSubmitted: false,
            isSaveNotifiication: false,
            isDisabledSend: false,
          });
        });
    //} else {
    //  this.validationsActivity.showMessages();
    //  showNotification.warning(
    //    `Warning: ${entitiesLabels.NOTIFICATION} required fields are missing  `
    //  );

    //  this.forceUpdate();
    //}
  };

  sendNotification = (notificationform) => {
    this.setState({
      isSaveNotifiication: true,
    });
    const { documents } = this.state;
    const { activities } = this.state;
    const datiForm = {
      id: this.state.inspectionModel.inspectionReport.notificationForm.id,
      distributionList: notificationform.distributionList,
      responsibleEmail: notificationform.responsibleEmail,
      documents,
      activities,
    };

    api
      .put('/inspection/notification/send', datiForm)
      .then(async (response) => {
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`,'Successfully sent');
          InspectionRepository.updateCachedInspectionList(this.state.inspectionModel);
          await InspectionRepository.updateCachedInspection(this.state.inspectionModel);
          this.getInspectionEdit(this.state.inspectionkey.id);
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`,
            getError('Unsuccessfully sent', entitiesLabels.INSPECTION, apioperation.POST)
          );
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.POST));
      })
      .finally(() => {
        this.setState({
          isSubmitted: false,
          isSaveNotifiication: false,
          isDisabledSend: true,
        });
      });
  };

  addDocument = (document) => {
    try {
      const oldInspectionDocument = this.state.documents || [];

      if (document.id != null) {
        // edit
        const { id } = document;
        const indexElement = oldInspectionDocument.findIndex((el) => el.id === id);
        if (indexElement > -1) {
          const newincidentEvents = [...oldInspectionDocument];
          newincidentEvents[indexElement] = document;
          this.updateState('incidentEventsw', newincidentEvents, 'incidentModel34t5');
        } else {
          showNotification.error();
        }
      } else {
        // insert

        document.id = uuid(); // id IncidentEvent
        const newinspectioDocument = oldInspectionDocument.concat([document]);
        this.updateState('documents', newinspectioDocument, 'inspectionModel');
      }

      this.setState({ isOpenModal: false });
    } catch (error) {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(entitiesLabels.INSPECTION, 'addDocument'));
    }
  };

  deleteDocument = (id) => {
    const documentsList = this.state.documents.filter((document) => document.id !== id);
    this.setState({
      documents: documentsList,
    });
  };

  addActivity = (activity) => {
    try {
      if (activity == null) return;

      const oldInspectionActivitys = this.state.activities || [];

      if (activity.id != null) {
        // edit
        const { id } = activity;
        const indexElement = oldInspectionActivitys.findIndex((el) => el.id === id); // //No GOOD
        if (indexElement > -1) {
          const newinspectioActivity = [...oldInspectionActivitys];
          newinspectioActivity[indexElement] = activity;
          this.updateStateActivity('activities', newinspectioActivity, 'inspectionModel');
        } else {
          showNotification.error();
        }
      } else {
        // insert
        activity.id = uuid(); // id IncidentEvent
        const newinspectioActivity = oldInspectionActivitys.concat([activity]);
        this.updateStateActivity('activities', newinspectioActivity, 'inspectionModel');
      }

      this.setState({ isOpenModal: false });
    } catch (error) {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(entitiesLabels.INSPECTION, 'addActivity'));
    }
  };

  deleteActivity = (id) => {
    const activitiesList = this.state.activities.filter((activity) => activity.id !== id);
    this.setState({
      activities: activitiesList,
    });
  };

  deleteInspector = (id) => {
    const inspectorList = this.state.inspector.filter((inspector) => inspector.id !== id);
    this.setState({
      inspector: inspectorList,
    });
  };

  onReportSummaryChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const inspection = { ...prevState.inspectionModel };
      inspection.inspectionReport.reportSummary = value;
      return { inspection };
    });
  }

  onAdditionalNoteChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const inspection = { ...prevState.inspectionModel };
      inspection.inspectionReport.additionalNotes = value;
      return { inspection };
    });
  }

  updateConsideration = async () => {
    this.setState({
      isSaveNotifiication: true,
    });
    try {
      this.setState({ isSubmitted: true });
      await api.put('/inspection/consideration', this.state.inspectionModel);
      InspectionRepository.updateCachedInspectionList(this.state.inspectionModel);
      InspectionRepository.updateCachedInspection(this.state.inspectionModel);
      showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.INSPECTION, apioperation.PUT));
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(entitiesLabels.INSPECTION, apioperation.PUT));
    } finally {
      this.setState({ isSubmitted: false, isSaveNotifiication: false });
    }
  };

  async onUpload(fileIdentifier, fileName, fileType, size) {
    const newAttach = {
      id: uuid(),
      fileIdentifier: fileIdentifier.blobName,
      name: fileName,
      contentType: fileType,
      size,
    };
    try {
      this.setState({ isSubmitted: true });
      await api.post(
        `/inspection/${this.state.inspectionModel.inspectionReport.id}/attachment`,
        newAttach
      );
      // showNotification.success(getSuccess(entitiesLabels.INSPECTION, apioperation.POST));
      const attach = { id: newAttach.id, idAttachment: newAttach.id, attachment: newAttach };
      return this.setState(async (prevState) => {
        const { inspectionReport } = prevState.inspectionModel;
        inspectionReport.attachments.push(attach);
        await InspectionRepository.updateCachedInspection(prevState.inspectionModel);
        return { inspectionReport };
      });
    } catch (error) {
      return showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.POST));
    } finally {
      this.setState({ isSubmitted: false });
    }
  }

  async onUploadAnswer(fileIdentifier, fileName, fileType, size) {
    const newAttach = {
      id: uuid(),
      fileIdentifier: fileIdentifier.blobName,
      name: fileName,
      contentType: fileType,
      size,
    };
    // const answer = this.state.inspectionModel.inspectionReport.checkList.answers.find(
    //   (item) => item.attachments.count !== 0 && item.id === this.state.idAnswerAttachment
    // );
    try {
      this.setState({ isSubmitted: true });
      await api.post(
        `/inspection/${this.state.inspectionModel.inspectionReport.id}/answer/${this.state.idAnswerAttachment}/attachment`,
        newAttach
      );
      const attach = { id: newAttach.id, idAttachment: newAttach.id, attachment: newAttach, idInspectionCheckListAnswer : this.state.idAnswerAttachment};
      return this.setState(async (prevState) => {
        const { inspectionReport } = prevState.inspectionModel;
        const answer = inspectionReport.checkList.answers.find(
          (item) => item.id === this.state.idAnswerAttachment
        );
        answer.attachments.push(attach);
        await InspectionRepository.updateCachedInspection(prevState.inspectionModel);
        return { inspectionReport };
      });
    } catch (error) {
      return showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.POST));
    } finally {
      this.setState({ isSubmitted: false });
    }
  }

  downloadAttachment = async (id) => {
    // const { attachments } = this.state.audit.attachments;
    const index = this.state.inspectionModel.inspectionReport.attachments.findIndex(
      (a) => a.id === id
    );
    let file;
    try {
      this.setState({ downloading: id });
      const fileA = this.state.inspectionModel.inspectionReport.attachments[index].attachment;
      file = (
        await api.getAll(
          `/inspection/${this.state.inspectionModel.id}/attachment/${fileA.fileIdentifier}`
        )
      ).data;
      this.downloadFile(file, fileA.name, fileA.contentType);
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.FileUpload, apioperation.GET));
    } finally {
      this.setState({ downloading: null });
    }
    return file;
  };

  getAttachmentUrl = (id) => {
    const index = this.state.inspectionModel.inspectionReport.attachments.findIndex(
      (a) => a.id === id
    );
    const fileA = this.state.inspectionModel.inspectionReport.attachments[index].attachment;
    return `/inspection/${this.state.inspectionModel.id}/attachment/${fileA.fileIdentifier}`;
  };

  getAttachmentName = (id) => {
    const index = this.state.inspectionModel.inspectionReport.attachments.findIndex(
      (a) => a.id === id
    );
    const fileA = this.state.inspectionModel.inspectionReport.attachments[index].attachment;
    return fileA.name;
  };

  // eslint-disable-next-line class-methods-use-this
  downloadFile(fileBytes, fileName, type) {
    const blob = new Blob([fileBytes, { type }]);
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  async onDeleteAttachment(Id) {
    const selectedItem = this.state.inspectionModel.inspectionReport.attachments.find(
      (item) => item.id === Id
    );

    try {
      this.setState({ isSubmitted: true });
      const { fileIdentifier } = selectedItem.attachment;

      await inspection.deleteAttach(
        `/inspection/${this.state.inspectionModel.inspectionReport.id}/attachment/${fileIdentifier} `
      );

      const index = this.state.inspectionModel.inspectionReport.attachments.indexOf(selectedItem);

      if (index > -1) {
        this.state.inspectionModel.inspectionReport.attachments.splice(index, 1);
      }
    } catch (error) {
      return showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.POST));
    } finally {
      this.setState({ isSubmitted: false });
    }
  }

  async onDeleteAttachmentAnswer(Id) {
    const answer = this.state.inspectionModel.inspectionReport.checkList.answers.find(
      (item) => item.attachments.count !== 0 && item.id === this.state.idAnswerAttachment
    );
    const selectedItem = answer.attachments.find((item) => item.id === Id);
    try {
      this.setState({ isSubmitted: true });
      const { fileIdentifier } = selectedItem.attachment;

      await inspection.deleteAttach(
        `/inspection/${this.state.inspectionModel.inspectionReport.id}/answer/${this.state.idAnswerAttachment}/attachment/${fileIdentifier} `
      );
      const index = answer.attachments.indexOf(selectedItem);
      if (index > -1) {
        answer.attachments.splice(index, 1);
      }
    } catch (error) {
      return showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.POST));
    } finally {
      this.setState({ isSubmitted: false });
    }
  }

  getAttachmentAnswerUrl = (id) => {
    const answer = this.state.inspectionModel.inspectionReport.checkList.answers.find(
      (item) => item.attachments.count !== 0 && item.id === this.state.idAnswerAttachment
    );
    const index = answer.attachments.findIndex((a) => a.id === id);
    const fileA = answer.attachments[index].attachment;
    return `/inspection/${this.state.inspectionModel.id}/answer/${this.state.idAnswerAttachment}/attachment/${fileA.fileIdentifier}`;
  };

  getAttachmentAnswerName = (id) => {
    const answer = this.state.inspectionModel.inspectionReport.checkList.answers.find(
      (item) => item.attachments.count !== 0 && item.id === this.state.idAnswerAttachment
    );
    const index = answer.attachments.findIndex((a) => a.id === id);
    const fileA = answer.attachments[index].attachment;
    return fileA.name;
  };

  downloadAttachmentAnswer = async (id) => {
    const answer = this.state.inspectionModel.inspectionReport.checkList.answers.find(
      (item) => item.attachments.count != 0 && item.id === this.state.idAnswerAttachment
    );
    const index = answer.attachments.findIndex((a) => a.id === id);
    let file;
    try {
      this.setState({ downloading: id });
      const fileA = answer.attachments[index].attachment;
      file = (
        await api.getAll(
          `/inspection/${this.state.inspectionModel.id}/answer/${this.state.idAnswerAttachment}/attachment/${fileA.fileIdentifier}`
        )
      ).data;
      this.downloadFile(file, fileA.name, fileA.contentType);
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.FileUpload, apioperation.GET));
    } finally {
      this.setState({ downloading: null });
    }
    return file;
  };

  // /Requirement
  showAddRequirement = (Template, Section) => {
    this.setState((oldState) => ({
      modalAddRequirementVisible: !oldState.modalAddRequirementVisible,
      addRequirementTemplate: Template,
      addRequirementSection: Section,
    }));
  };

  showDeleteRequirement(id) {
    this.setState((oldState) => ({
      modalDeleteRequirementVisible: !oldState.modalDeleteRequirementVisible,
      requirementToDelete: id,
    }));
  }

  showModifyRequirement = (idCheckListAnswer, requirement) => {
    this.setState((oldState) => ({
      modalUpdateRequirementVisible: !oldState.modalUpdateRequirementVisible,
      requirementToModify: requirement,
      checkListRequirementToModify: idCheckListAnswer,
    }));
  };

  checkListRequirementUpdated = (item) => {
    const { answers } = this.state.inspectionModel.inspectionReport.checkList;
    const index = answers.findIndex((qa) => qa.requirement?.id === item?.id);
    answers[index].requirement = item;
    this.setState((prevState) => {
      const state = { ...prevState };
      state.modalUpdateRequirementVisible = !prevState.modalUpdateRequirementVisible;
      state.isSubmitted = false;
      state.inspectionModel.inspectionReport.checkList.answers = answers;
      InspectionRepository.updateCachedInspection(state.inspectionModel);
      return state;
    });
  };

  newCheckListRequirementAdded = (item) => {
    const { answers } = this.state.inspectionModel.inspectionReport.checkList;
    let count = 0;
    for (let answer in answers) {
      if ((answer = !null)) ++count;
    }
    //answers[count] = item;
    answers[count] = {...item, active:true}; //RITM0937302
    this.setState((prevState) => {
      const state = { ...prevState };
      state.modalAddRequirementVisible = !prevState.modalAddRequirementVisible;
      state.isSubmitted = false;
      state.inspectionModel.inspectionReport.checkList.answers = answers;
      InspectionRepository.updateCachedInspection(state.inspectionModel);
      return state;
    });
  };

  handleRequirementDeleteCancel = () => {
    this.setState((oldState) => ({
      modalDeleteRequirementVisible: !oldState.modalDeleteRequirementVisible,
      requirementToDelete: null,
    }));
  };

  handleRequirementDelete = async () => {
    try {
      this.setState({ isSubmitted: true, isDeletingReq: true });
      await api.delete('/inspection/checklistquestion/', this.state.requirementToDelete);
      const { answers } = this.state.inspectionModel.inspectionReport.checkList;

      const index = answers.findIndex(
        (qa) => qa.requirement?.id === this.state.requirementToDelete
      );
      answers.splice(index, 1);
      this.setState((prevState) => {
        const inspection = { ...prevState.inspectionModel.inspectionReport };
        inspection.checkList.answers = answers;
        return { inspection };
      });
      showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.REQUIREMENT, apioperation.DELETE));
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(entitiesLabels.REQUIREMENT, apioperation.DELETE));
      throw error;
    } finally {
      this.setState((oldState) => ({
        isSubmitted: false,
        modalDeleteRequirementVisible: !oldState.modalDeleteRequirementVisible,
        requirementToDelete: null,
        isDeletingReq: false,
      }));
    }
  };

  renderRequirementDeleteModal = () => {
    const modalHeader = {
      title: 'Delete Custom Requirement',
      iconDescription: 'Close',
      buttonOnClick: () => this.handleRequirementDeleteCancel(),
    };
    return (
      this.state.modalDeleteRequirementVisible && (
        <ComposedModal
          className="light-modal"
          open
          danger="false"
          onClose={() => {
            this.handleRequirementDeleteCancel();
          }}
        >
          <ModalHeader className="margin-modal" {...modalHeader}>
            <p />
          </ModalHeader>
          {this.state.isDeletingReq ? <Loading /> : ''}
          <ModalBody className="margin-modal">
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <h5 className="align-center">
                    Press confirm to delete selected custom requirement
                  </h5>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button kind="secondary" onClick={this.handleRequirementDeleteCancel}>
              Cancel
            </Button>
            <Button kind="primary" onClick={this.handleRequirementDelete}>
              Save
            </Button>
          </ModalFooter>
        </ComposedModal>
      )
    );
  };

  // getCar(qa) { 
  getCar(qa, item) { //RITM0937302
    const confirmDelProps = () => ({
      idToDelete: this.state.idToDelete,
      nameItem: 'CAR',
      isDeleting: this.state.isDeleting,
      open: this.state.isOpenDeleteModal, // open state
      onCloseConfirm: this.onCloseConfirm, // no click
      deleteItem: () => this.onDeleteCar(this.state.idAnswerToDelete, this.state.idToDelete), // yes click fn()
    });

    return (
      <>
        {!qa.car ? (
          <Button
            className="selection-item "
            disabled={this.state.editingDisabled || this.state.inspectionModel.idStatusReport === 4
              || !item.active} //RITM0937302
            id={`btn${qa.id}`}
            key={`btn${qa.id}`}
            size="small"
            kind="tertiary"
            renderIcon={Add16}
            onClick={() =>
              this.showModalCar(qa.id, qa.question?.code, `${qa.section?.code} ${qa.section?.name}`)
            }
          >
            Associate CAR
          </Button>
        ) : (
          <>
            <ConfirmAlertCustom {...confirmDelProps()} />

            <div className="selection-item ">
              <div className="dox-actions-detail">{qa.car.inspectionCARCode}</div>

              {IsEditable(
                'Inspection',
                'CARSimplified',
                this.context.user,
                qa.car.idStatus,
                'DueDate',
                this.getCanEditResource()
              ) && this.IsRowSelectable() && item.active ? ( //RITM0937302
                <>
                  <Button
                    key={qa.car.id}
                    id={qa.car.id}
                    size="small"
                    renderIcon={Edit16}
                    iconDescription="Edit"
                    onClick={() => this.showModalUpdateCar(qa.car)}
                    kind="ghost"
                    className="checklist-custom-content-detail"
                    disabled={this.props.disabled}
                  />
                  <Online>
                    <Button
                      key={qa.car.id}
                      id={qa.car.id}
                      size="small"
                      renderIcon={Delete16}
                      iconDescription="Delete"
                      onClick={() => this.confirmDeleteCAR(qa.car.id, qa.car.idAnswer)}
                      kind="ghost"
                      className="checklist-custom-content-info "
                      disabled={this.props.disabled}
                    />
                  </Online>
                </>
              ) : null}
              <Link
                to={
                  /inspection/ +
                  this.state.inspectionkey.id +
                  /answer/ +
                  qa.car.idAnswer +
                  /car/ +
                  qa.car.id
                }
              >
                <Button
                  size="small"
                  renderIcon={View16}
                  title="View Inspection Report"
                  iconDescription="View Inspection Report"
                  kind="ghost"
                />
              </Link>
              <div className="item-tag-inline">
                <StatusTag value={qa.car.status && qa.car.status.carSimplifiedName} />
              </div>
            </div>
          </>
        )}
      </>
    );
  }

  onCloseConfirm = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  confirmDeleteCAR = (id, idAnswer) => {
    this.setState({
      idAnswerToDelete: idAnswer,
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  onDeleteCar = (idAnswer, id) => {
    this.setState({
      isDeleting: true,
    });
    api
      .delete(`/inspection/${this.props.match.params.id}/answer/${idAnswer}/car/${id}`, '')
      .then((response) => {
        if (response.status === 200) {
          const id = this.state.inspectionKey;

          const { answers } = this.state.inspectionModel.inspectionReport.checkList;

          const index = answers.findIndex((qa) => qa.id === idAnswer);

          answers[index].car = null;
          this.onCloseConfirm();
          this.setState((prevState) => {
            const state = { ...prevState };
            state.inspectionModel.inspectionReport.checkList.answers = answers;
            // this.repository.updateCachedAudit(this.state.inspectionModel);      TODO
            showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.CAR, apioperation.DELETE));
            return state;
          });
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isDeleting: false,
        });
      });
  };

  showModalAttachment = (id) => {
    this.setState({
      idAnswerAttachment: id,
      isOpenModalAttachment: true,
    });
  };

  closeModalAttachment = () => {
    this.setState({
      isOpenModalAttachment: false,
    });
  };

  modalAttachment() {
    const modalHeader = {
      title: 'Attachments',
      iconDescription: 'Close',
      buttonOnClick: () => this.closeModalAttachment(),
    };

    return (
      <div style={{ display: this.state.isOpenModalAttachment ? 'block' : 'none' }}>
        <ComposedModal className="light-modal" open danger="false" onClose={() => false}>
          <ModalHeader className="margin-modal" {...modalHeader}>
            <p />
          </ModalHeader>
          <ModalBody className="margin-modal">
            {!this.state.editingDisabled && (
              <div className="bx--col-lg-6 bx--col-md-6 element-detail-layout">
                <FileUpload
                  Container="saipem"
                  StoragePath="inspection"
                  onUpload={this.onUploadAnswer}
                  disabled={this.state.editingDisabled}
                />
              </div>
            )}
            <TableContainer>
              <Table>
                <TableHead className="colorgray">
                  <TableRow>
                    <TableHeader>Name</TableHeader>
                    <TableHeader>Size</TableHeader>
                    <TableHeader className="align-center">Actions</TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.inspectionModel?.inspectionReport?.checkList?.answers?.map((answer) =>
                    answer.attachments != [] && answer.id === this.state.idAnswerAttachment ? (
                      answer.attachments < 1 ? (
                        <NoRecordsPlaceholder labelText="No Records" colSpan={3} />
                      ) : (
                        answer.attachments.map((item) => (
                          <TableRow key={`row_${item.id}`}>
                            <TableCell key={`cell_1_${item.id}`}>
                              {item?.attachment?.name}
                            </TableCell>
                            <TableCell key={`cell_2_${item.id}`}>
                              {sizeFormat(item?.attachment?.size)}
                            </TableCell>
                            <TableCell
                              key={`action-${item.id}`}
                              className="tableActions align-center"
                            >
                              {this.state.downloading === item.id ? (
                                <div>
                                  <InlineLoading
                                    description=""
                                    iconDescription="downloading.."
                                    status="active"
                                  />
                                </div>
                              ) : (
                                <div>
                                  <Online>
                                    <FileDownLoadButton
                                      onError={(error) => {
                                        showNotification.error(`${entitiesLabels.ERROR}`,
                                          getError(
                                            error,
                                            entitiesLabels.FileUpload,
                                            apioperation.GET
                                          )
                                        );
                                      }}
                                      onDownLoadStart={() =>
                                        this.setState({ downloading: item.id })
                                      }
                                      onDownLoadEnd={() => this.setState({ downloading: null })}
                                      apiUrl={this.getAttachmentAnswerUrl(item.id)}
                                      fileName={this.getAttachmentAnswerName(item.id)}
                                      size="small"
                                      renderIcon={View16}
                                      iconDescription="Download"
                                      kind="ghost"
                                      // disabled={this.state.editingDisabled}
                                    />
                                  </Online>
                                  <Offline>
                                    <Button
                                      size="small"
                                      renderIcon={View16}
                                      iconDescription="Download"
                                      kind="ghost"
                                      disabled
                                    />
                                  </Offline>
                                  <Online>
                                    {!this.state.editingDisabled && (
                                      <Button
                                        onClick={() => this.onDeleteAttachmentAnswer(item.id)}
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                        disabled={this.state.editingDisabled}
                                      />
                                    )}
                                  </Online>
                                  <Offline>
                                    <Button
                                      size="small"
                                      renderIcon={Delete16}
                                      iconDescription="Delete"
                                      kind="ghost"
                                      disabled
                                    />
                                  </Offline>
                                </div>
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      )
                    ) : (
                      ''
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </ModalBody>
        </ComposedModal>
      </div>
    );
  }

  onDetailsOfInefficiencyChange(event) {
    const { value } = event.currentTarget;
    this.setState({
      carModel: {
        ...this.state.carModel,
        detailsOfInefficiency: value,
      },
    });
  }

    modalCar() {
    var diffduedate = false;
    if (this.state.carModel.dueDate != null) {
       diffduedate =
        !this.state.carModel.dueDate ||
        moment(this.state.carModel.dueDate).isSameOrAfter(
          moment(this.state.inspectionReport?.notificationForm?.startDate),
          'day'
        );
    } else {
       diffduedate = true;
    }
    const modalHeader = {
      title: this.state.isUpdateDocument ? 'Edit Car' : 'Add new CAR/CA',
      iconDescription: 'Close',
      buttonOnClick: () => this.closemodalCar(),
    };
    const validationCar = {
      detailsOfInefficiency: this.validationsCar.message(
        'Details of inefficiency',
        this.state.carModel.detailsOfInefficiency,
        'required'
      ),
      dueDate: this.validationsCar.message('DueDate', this.state.carModel.dueDate, 'required'),
      email: this.validationsCar.message('Car Owner', this.state.ownerModel.email, 'required'),
      duedate: this.validationsCar.message('Due Date ', diffduedate, 'accepted'),
    };
    return this.state.mode === 2 ? (
      <FindSaipemCompilers
        isOpenModal={this.state.mode === 2}
        url={`/inspection/${this.state.inspectionModel.id}/car/compilers/`}
        onCancel={() => this.handleChangeMode(0)}
        onOk={this.setSaipemOwner}
      />
    ) : (
      <div style={{ display: this.state.isOpenModalCar ? 'block' : 'none' }}>
        {!this.state.isOpenModalGHRS ? (
          <ComposedModal className="light-modal" open danger="false" onClose={() => false}>
            <ModalHeader className="margin-modal" {...modalHeader}>
              <p />
            </ModalHeader>
            <ModalBody className="margin-modal">
              <div className="bx--grid--full-width">
                <div className="bx--row">
                  {this.state.isSaveCar && <Loading />}

                  <Form className="bx--grid--full-width form--multi ">
                    {this.state.isLoadingElement ? <Loading /> : ''}
                    <div className="bx--row ">
                      <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel className="some-class">Due Date*</FormLabel>
                        {this.state.isLoadingDate ? (
                          <DatePickerSkeleton />
                        ) : (
                          <DateTimePicker
                            value={this.state.carModel.dueDate}
                            type="date"
                            placeholder={DateFormat}
                            name="dueDate"
                            alt="carModel"
                            invalid={validationCar.dueDate != null}
                            onChange={this.updateStateDPCAR}
                          />
                        )}

                        {validationCar.dueDate}
                        {validationCar.duedate ? (
                          <div className="srv-validation-message">
                            {' '}
                            Event date less than the expiration date{' '}
                          </div>
                        ) : null}
                      </FormGroup>

                      <FormGroup legendText="Find Owner on GHRS*" className="bx--col-md-4">
                        <div className="bx--row two-button-center">
                          <Button
                            kind="primary"
                            className="bx--col"
                            onClick={() => this.showGHRS()}
                          >
                            GHRS research
                          </Button>
                          <div className="bx--col-lg-6 bx--col-md-6">
                            <Button
                              kind="primary"
                              className="bx--col"
                              onClick={() => this.handleChangeMode(2)}
                            >
                              Saipem research
                            </Button>
                          </div>
                        </div>
                        {validationCar.email}
                      </FormGroup>

                      <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel className="some-class">Owner Full Name*</FormLabel>
                        <TextInput
                          id="idEmployer"
                          name="idEmployer"
                          placeholder="Search Car Owner"
                          required
                          value={
                            this.state.ownerModel.fullname ? this.state.ownerModel.fullname : ''
                          }
                          type="text"
                          labelText=""
                          className="bx--text-input  bx--text-input--light camp--description "
                          disabled
                          //  invalid={validations.descriptionCar != null}
                        />
                      </FormGroup>
                      <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel className="some-class">Owner Email*</FormLabel>
                        <TextInput
                          id="idEmployer"
                          name="idEmployer"
                          placeholder="Search Car Owner"
                          required
                          value={this.state.ownerModel.email ? this.state.ownerModel.email : ''}
                          type="text"
                          labelText=""
                          className="bx--text-input  bx--text-input--light camp--description "
                          disabled
                          //  invalid={validations.descriptionCar != null}
                        />
                      </FormGroup>

                      <FormGroup legendText="Details Of Inefficiency*">
                        <TextArea
                          maxLength={5000}
                          labelText=""
                          id="inputDetailOfInefficiency"
                          name="inputdetailsofinefficiency"
                          cols={250}
                          disabled={false}
                          invalid={validationCar.detailsOfInefficiency}
                          // invalidText="required"
                          light
                          placeholder="Input Details of inefficiency"
                          rows={5}
                          value={this.state.carModel.detailsOfInefficiency == null ? '' : this.state.carModel.detailsOfInefficiency}
                          onChange={this.onDetailsOfInefficiencyChange}
                        />
                      </FormGroup>
                      {validationCar.detailsOfInefficiency}
                    </div>
                  </Form>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button kind="secondary" onClick={() => this.closemodalCar()}>
                Cancel
              </Button>
              <Button kind="primary" onClick={() => this.saveCar()}>
                Save
              </Button>
            </ModalFooter>
          </ComposedModal>
        ) : (
          <FindGHRSEmployer
            isOpenModal={this.state.isOpenModalGHRS}
            onCancel={this.handleChangeGHRSModal}
            onOk={this.setEmployer}
          />
        )}
      </div>
    );
  }

  renderTabs = () => (
    <>
      <PageBreadCrumb
        linkTo="/inspection?isBack"
        linkText="Inspection List"
        titleLeft="Inspection Report"
        batchActions={this.getStatusActions(this.context.user)}
        showButtonHistory={this.showButtonHistory()}
        titleCenter={
          this.state.inspectionModel && this.state.inspectionModel.inspectionCode
            ? `ID: ${this.state.inspectionModel.inspectionCode}`
            : ''
        }
        titleRight={
          this.state.inspectionModel && this.state.inspectionModel.inspectionReport
            ? this.state.inspectionModel.inspectionReport.status.reportingName
            : null
        }
      />
      <div className="mainContainer">
        <WFActionModal
          show={this.state.isApprovalModalOpen}
          title={`${this.state.approvalModalAction} Inspection`}
          action={this.state.approvalModalAction}
          withApprover={this.state.withApprover}
          approver={this.state.approver}
          approverRole={this.state.approverRole}
          approverOptions={this.state.approvers}
          isLoadingOperation={this.state.isLoadingWFOperation}
          onApproverSelect={this.handleApproverSelect}
          isLoadingOptions={this.state.isLoadingApproverOptions}
          onCancel={this.handleCloseApprovalModal}
          onConfirm={this.handleConfirmApprovalModal}
          onApprovalNotesChange={this.handleApprovalNotesChange}
          approvalNotes={this.state.approvalNotes}
          approvalNotesRequired={this.state.approvalNotesRequired}
          validationMessages={this.state.approvalValidationMessages}
        />
        {this.state.inspectionModel && this.state.inspectionModel.inspectionReport && (
          <HistoryTable
            entityId={this.state.inspectionModel.inspectionReport.id}
            isOpenModal={this.state.isHistoryModalOpen}
            onClose={() => this.closeModalHistory()}
          />
        )}
        {this.modalCar()}
        {this.modalAttachment()}
        {this.renderRequirementDeleteModal()}
        {this.state.modalAddRequirementVisible ? (
          <CheckListRequirement
            CheckList={this.state.inspectionModel.inspectionReport.checkList}
            Section={this.state.addRequirementSection}
            Template={this.state.addRequirementTemplate}
            onSave={this.newCheckListRequirementAdded}
            onCancel={this.showAddRequirement}
          />
        ) : null}
        {this.state.modalUpdateRequirementVisible ? (
          <CheckListRequirement
            idCheckListAnswer={this.state.checkListRequirementToModify}
            Requirement={this.state.requirementToModify}
            onUpdate={this.checkListRequirementUpdated}
            onCancel={this.showModifyRequirement}
          />
        ) : null}
        <div className="bx--grid content full-width mainContainer ">
          <div className="bx--row">
            <div className="bx--col detail--information">
                          <InspectionInformation
                              tabsLoading={this.state.tabsLoading}
                              inspectionInfo={this.state.inspectionModel}
                              editingDisabledCheck={this.state.editingDisabled}
                              onDateChange={this.mainInfoDateChange}
                              //RITM0560302
                              onProjectAreaChange={this.mainInfoProjectAreaChange}
                          />
            </div>
          </div>
          <div className="bx--row">
            {this.state.tabsLoading ? (
              <div className="bx--col-lg-12 bx--tab-container">
                <TabsSkeleton className="auditReportTab" />
              </div>
            ) : (
              <Tabs
                ariaLabel="listbox"
                className="auditReportTab"
                iconDescription="show menu options"
                onKeyDown={() => {}}
                role="navigation"
                selected={0}
                tabContentClassName="auditReportTab"
                triggerHref="#"
                type="default"
              >
                <Tab
                  href="#"
                  label="Notification Form"
                  onClick={() => {}}
                  onKeyDown={() => {}}
                  role="presentation"
                  selected={false}
                  tabIndex={0}
                >
                 <InspectionNotification
                                          // PROPS
                                          notificationForm={this.state.notificationForm}
                                          activities={this.state.activities}
                                          documents={this.state.documents}
                                          inspectionModel={this.state.inspectionModel}
                                          // /FUNZTIONS
                                          addActivity={this.addActivity}
                                          addDocument={this.addDocument}
                                          saveNotificationForm={this.saveNotificationForm}
                                          sendNotification={this.sendNotification}
                                          deleteDocument={this.deleteDocument}
                                          deleteActivity={this.deleteActivity}
                                          updateDocument={this.updateDocument}
                                          isLoad={this.state.isSaveNotifiication}
                                          editingDisabledCheck={this.state.editingDisabled}
                                          key={this.state.notifKey ?? ''}
                                          isDisabledSendButton={this.state.isDisabledSend}
                                      />
                </Tab>
                 <Tab
                  href="#"
                  label="Personnel"
                  onClick={() => {}}
                  onKeyDown={() => {}}
                  role="presentation"
                  selected={false}
                  tabIndex={0}
                  disabled={!this.state.notificationForm.sendedOn}
                >
                  <InspectionPersonnel
                    id="PersonnelSection"
                    worksite={this.state.inspectionModel.idWorkSite}
                    inspectionInfo={this.state.inspectionModel}
                    inspectors={this.state.inspectionsinspector}
                    deleteInspector={this.deleteInspector}
                    disabled={this.state.editingDisabled}
                    plan={this.state.idPlan}
                    editingDisabledCheck={this.state.editingDisabled}
                  />
                </Tab>
                <Tab
                  href="#"
                  label="Requirements"
                  onClick={() => this.showRequirment()}
                  onKeyDown={() => {}}
                  role="presentation"
                  selected={false}
                  tabIndex={0}
                  disabled={!this.state.notificationForm.sendedOn}
                >
                  {this.state.isSubmitted && <Loading />}
                  <div className="bx--row main-information-itmes">
                    <div className="bx--col-lg-3 bx--col-md-3">
                      <h5>Requirements</h5>
                    </div>
                    {!this.state.editingDisabled && (
                      <div className="bx--col-lg-9 bx--col-md-9 main-information-button">
                        <Button
                          size="default"
                          renderIcon={Save16}
                          kind="primary"
                          onClick={this.updateCheckList}
                          // disabled={this.state.editingDisabled}
                        >
                          Save
                        </Button>
                      </div>
                    )}
                  </div>

                  {this.state.isLoadtemplate ? (
                    <Tabs>
                      {this.getTemplate().map((item) => (
                        <Tab
                          href="#"
                          label={`${item.code} - ${item.name}`}
                          className={`${item.active ? "bx--tabs__nav-link_is_active" : "bx--tabs__nav-link_is_not_active"} `} //RITM0937302
                          onClick={() => {}}
                          onKeyDown={() => {}}
                          role="presentation"
                          selected={false}
                          tabIndex={0}
                          id={item.id}
                          key={item.id}
                        >
                          <div className="some-content">
                            <Accordion>
                              {/* RITM0937302 */}
                              <div className="bx--row main-information-itmes padding-bottom-low-rem">
                                  <div className="padding-left-right-accordion">
                                    <Toggle
                                        toggled={item.active}
                                        onToggle={() => this.toggleActiveTemplateQuestions(item.id)}
                                        className="toggle-bg-orange mb-20px"
                                        labelText="Template Enabled"
                                        aria-label=""
                                        disabled={this.state.editingDisabled}
                                        id={`toggle-1 - ${item.id}`}
                                    />
                                  </div>
                              </div>
                              {this.getSections(item.id).map((section) => (
                                <AccordionItem
                                  className="auditAccordionTitle"
                                  title={` ${section.name}`}
                                  id={section.id}
                                  key={section.id}
                                >
                                  <div className="bx--row">
                                    {!this.state.editingDisabled && (
                                      <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12 main-information-button-detail ">
                                        <Button
                                          disabled={
                                            this.state.editingDisabled ||
                                            this.state.inspectionModel.idStatusReport === 4 ||
                                            !item.active //RITM0937302
                                          }
                                          renderIcon={Add16}
                                          onClick={() => this.showAddRequirement(item, section)}
                                        >
                                          Add Requirement
                                        </Button>
                                      </div>
                                    )}
                                  </div>
                                  {this.getQuestionAnswer(section.id).map((qa) => (
                                    <div id={`div${qa.id}`} key={`div${qa.id}`}>
                                      <CheckListQuestionAnswer
                                        id={qa.id}
                                        key={qa.id}
                                        questionCode={qa.question.code}
                                        question={qa.question.name}
                                        answer={qa.answer}
                                        note={qa.notes}
                                        disabled={this.state.editingDisabled || !item.active} //RITM0937302
                                        onAnswerChange={(answer) =>
                                          this.onAnswerChange(qa.id, answer)
                                        }
                                        onNoteChange={(note) => this.onNoteChange(qa.id, note)}
                                      />
                                      <div className="bx--row">
                                        <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12 main-information-button-content selection-linear">
                                          {/* RITM0937302 */}
                                          {/* {this.getCar(qa)} */}
                                          {this.getCar(qa, item)}

                                          <Button
                                            className="button-items--modal"
                                            kind="primary"
                                            size="small"
                                            renderIcon={Attachment16}
                                            onClick={() => this.showModalAttachment(qa.id)}
                                            disabled={this.state.editingDisabled || !item.active} //RITM0937302
                                          >
                                            Attachments
                                          </Button>
                                          <div className="button-items--modal">
                                            {qa.attachments.length > 0 ? (
                                              <span className="main-information-span ">
                                                Attachments: {qa.attachments.length}
                                              </span>
                                            ) : (
                                              ''
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                  {this.getRequirementAnswer(section.id).map((qa) => (
                                    <div id={`div${qa.id}`} key={`div${qa.id}`}>
                                      <CheckListQuestionAnswer
                                        id={qa.id}
                                        key={qa.id}
                                        questionCode={qa.requirement.code}
                                        question={qa.requirement.name}
                                        answer={qa.answer}
                                        note={qa.notes}
                                        onAnswerChange={(answer) =>
                                          this.onAnswerChange(qa.id, answer)
                                        }
                                        isCustom
                                        onDeleteCustomRequirement={() =>
                                          this.showDeleteRequirement(qa.requirement.id)
                                        }
                                        onUpdateCustomRequirement={() =>
                                          this.showModifyRequirement(qa.id, qa.requirement)
                                        }
                                        onNoteChange={(note) => this.onNoteChange(qa.id, note)}
                                        disabled={this.state.editingDisabled || !item.active} //RITM0937302
                                      />
                                      <div className="bx--row">
                                        <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12 main-information-button-content selection-linear">
                                          {/* RITM0937302 */}
                                          {/* {this.getCar(qa)} */}
                                          {this.getCar(qa, item)}
                                          <Button
                                            className="button-items--modal "
                                            kind="primary"
                                            size="small"
                                            renderIcon={Attachment16}
                                            onClick={() => this.showModalAttachment(qa.id)}
                                            disabled={this.state.editingDisabled || !item.active} //RITM0937302
                                          >
                                            Attachments
                                          </Button>
                                          <div className="button-items--modal">
                                            {qa.attachments ? (
                                              qa.attachments.length > 0 ? (
                                                <span className="main-information-span ">
                                                  Attachments: {qa.attachments.length}
                                                </span>
                                              ) : (
                                                ''
                                              )
                                            ) : (
                                              ''
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </AccordionItem>
                              ))}
                            </Accordion>
                          </div>
                        </Tab>
                      ))}
                    </Tabs>
                  ) : null}
                </Tab>
                <Tab
                  href="#"
                  label="Report Summary"
                  onClick={() => {}}
                  onKeyDown={() => {}}
                  role="presentation"
                  selected={false}
                  tabIndex={0}
                  disabled={!this.state.notificationForm.sendedOn}
                >
                  <div className="some-content">
                    {this.state.isSaveNotifiication ? <Loading /> : ''}
                    <Tile light>
                      <div className="bx--row">
                        <div className="bx--col-lg-12 bx--col-md-12">
                          <FormGroup legendText="Report Summary (The mention of names and surnames must be done only if strictly necessary)">
                            <TextArea
                              maxLength={5000}
                              labelText=""
                              id="inputReportSummary"
                              name="inputReportSummary"
                              cols={250}
                              disabled={this.state.editingDisabled}
                              invalid={false}
                              invalidText="required"
                              light
                              placeholder=""
                              rows={10}
                              value={
                                this.state.inspectionModel?.inspectionReport?.reportSummary || ''
                              }
                              onChange={this.onReportSummaryChange}
                            />
                          </FormGroup>
                        </div>
                        <div className="bx--col-lg-12 bx--col-md-12">
                          <FormGroup legendText="Additional Notes (The mention of names and surnames must be done only if strictly necessary)">
                            <TextArea
                              maxLength={5000}
                              labelText=""
                              id="inputAdditionalNotes"
                              name="inputAdditionalNotes"
                              cols={250}
                              disabled={this.state.editingDisabled}
                              invalid={false}
                              invalidText="required"
                              light
                              placeholder=""
                              rows={10}
                              value={
                                this.state.inspectionModel?.inspectionReport?.additionalNotes || ''
                              }
                              onChange={this.onAdditionalNoteChange}
                            />
                          </FormGroup>
                        </div>
                        {!this.state.editingDisabled && (
                          <div className="bx--col-lg-12 bx--col-md-12 main-information-button">
                            <Button
                              size="default"
                              renderIcon={Save16}
                              kind="primary"
                              onClick={this.updateConsideration}
                              disabled={this.state.editingDisabled}
                            >
                              Save
                            </Button>
                          </div>
                        )}
                      </div>
                    </Tile>
                    <Tile className="bx--tile bx--tile--light">
                      {!this.state.editingDisabled && (
                        <div className="bx--col-lg-6 bx--col-md-6">
                          <FileUpload
                            Container="saipem"
                            StoragePath="inspection"
                            onUpload={this.onUpload}
                            disabled={this.state.editingDisabled}
                            title="&#9888; It is forbidden to upload photos wich show people's faces. It is also forbidden to upload photos on which it is possible to recognize specific people"
                          />
                        </div>
                      )}
                    </Tile>
                    <Tile className="bx--tile bx--tile--light">
                      <div className="bx--col-lg-12 bx--col-md-12">
                        <TableContainer className="bx--grid--full-width">
                          <Table>
                            <TableHead className="colorgray">
                              <TableRow>
                                <TableHeader>Name</TableHeader>
                                <TableHeader>Size</TableHeader>
                                <TableHeader className="align-center">Actions</TableHeader>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.inspectionModel?.inspectionReport?.attachments < 1 ? (
                                <NoRecordsPlaceholder labelText="No Records" colSpan={3} title="It is forbidden to upload photos which show people's faces. It is also forbidden to uplad photos on which it is possible to recognize specific people" />
                              ) : (
                                this.state.inspectionModel?.inspectionReport?.attachments?.map(
                                  (item) => (
                                    <TableRow key={`row_${item.id}`}  >
                                      <TableCell key={`cell_1_${item.id}`}title="It is forbidden to upload photos which show people's faces. It is also forbidden to uplad photos on which it is possible to recognize specific people">
                                        {item?.attachment?.name}
                                      </TableCell>
                                      <TableCell key={`cell_2_${item.id}`}>
                                        {sizeFormat(item?.attachment?.size)}
                                      </TableCell>
                                      <TableCell
                                        key={`action-${item.id}`}
                                        className="tableActions align-center"
                                      >
                                        {this.state.downloading === item.id ? (
                                          <div>
                                            <InlineLoading
                                              description=""
                                              iconDescription="downloading.."
                                              status="active"
                                            />
                                          </div>
                                        ) : (
                                          <div>
                                            <Online>
                                              <FileDownLoadButton
                                                onError={(error) => {
                                                  showNotification.error(`${entitiesLabels.ERROR}`,
                                                    getError(
                                                      error,
                                                      entitiesLabels.FileUpload,
                                                      apioperation.GET
                                                    )
                                                  );
                                                }}
                                                onDownLoadStart={() =>
                                                  this.setState({ downloading: item.id })
                                                }
                                                onDownLoadEnd={() =>
                                                  this.setState({ downloading: null })
                                                }
                                                apiUrl={this.getAttachmentUrl(item.id)}
                                                fileName={this.getAttachmentName(item.id)}
                                                size="small"
                                                renderIcon={View16}
                                                iconDescription="Download"
                                                kind="ghost"
                                                // disabled={this.state.editingDisabled}
                                              />
                                            </Online>
                                            <Offline>
                                              <Button
                                                size="small"
                                                renderIcon={View16}
                                                iconDescription="Download"
                                                kind="ghost"
                                                disabled
                                              />
                                            </Offline>
                                            {/* <Button
                                              onClick={() => this.downloadAttachment(item.id)}
                                              size="small"
                                              renderIcon={View16}
                                              iconDescription="Download"
                                              kind="ghost"
                                              disabled={this.state.editingDisabled}
                                            /> */}
                                            {(IsInRole(this.context.user, 'Administrator') ||
                                              IsInRole(this.context.user, 'Compiler')) && (
                                              <>
                                                <Online>
                                                  <Button
                                                    onClick={() => this.onDeleteAttachment(item.id)}
                                                    size="small"
                                                    renderIcon={Delete16}
                                                    iconDescription="Delete"
                                                    kind="ghost"
                                                    disabled={this.state.editingDisabled}
                                                  />
                                                </Online>
                                                <Offline>
                                                  <Button
                                                    size="small"
                                                    renderIcon={Delete16}
                                                    iconDescription="Delete"
                                                    kind="ghost"
                                                    disabled
                                                  />
                                                </Offline>
                                              </>
                                            )}
                                          </div>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  )
                                )
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    </Tile>
                  </div>
                </Tab>
                <Tab
                  href="#"
                  label="CARs List"
                  disabled={!this.state.notificationForm.sendedOn}
                  onClick={() => {
                    this.props.history.push(`/inspection/${this.props.match.params.id}/car`);
                  }}
                  selected={false}
                  tabIndex={0}
                />
                <Tab
                    href="#"
                    label="Report Distribution"
                    disabled={!this.state.notificationForm.sendedOn}
                    onClick={() => { }}
                    selected={false}
                    tabIndex={0}
                >
                    <InspectionDistribution inspectionModel={this.state.inspectionModel} />
                </Tab>
              </Tabs>
            )}
          </div>
        </div>
      </div>
    </>
  );

  // WF
  getStatusActions = (user) => {
    if (!this.IsRowSelectable()) return null;

    return (
      <Online>
        <>
          {CanExecuteAction(
            'Inspection',
            'Reporting',
            user,
            this.state.inspectionModel.inspectionReport.idStatus,
            'Submit',
            //RITM0577262
            this.state.inspectionModel.inspectionReport
          ) ? (
            <Button
              renderIcon={Send16}
              onClick={() =>
                this.batchActionClick('submitreport', 'Submit', 'Data Approver', true, false, null)
              }
            >
              Submit Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Inspection',
            'Reporting',
            user,
            this.state.inspectionModel.inspectionReport.idStatus,
            'Approve',
            //RITM0577262
            this.state.inspectionModel.inspectionReport
          ) ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() =>
                this.batchActionClick(
                  'approvereport',
                  'Approve',
                    null, /*RUOLI_APPROVATIVI_DEV_255_RITM0565449*/
                    false, /*RUOLI_APPROVATIVI_DEV_255_RITM0565449*/
                  false,
                  null
                )
              }
            >
              Approve Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Inspection',
            'Reporting',
            user,
            this.state.inspectionModel.inspectionReport.idStatus,
            'Consolidate',
            //RITM0577262
            this.state.inspectionModel.inspectionReport
          ) ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() =>
                this.batchActionClick('consolidatereport', 'Consolidate', null, false, false, null)
              }
            >
              Consolidate Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Inspection',
            'Reporting',
            user,
            this.state.inspectionModel.inspectionReport.idStatus,
            'Reject',
            //RITM0577262
            this.state.inspectionModel.inspectionReport
          ) ? (
            <Button
              renderIcon={Error16}
              onClick={() =>
                this.batchActionClick('rejectreport', 'Reject', null, false, true, null)
              }
            >
              Reject Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Inspection',
            'Reporting',
            user,
            this.state.inspectionModel.inspectionReport.idStatus,
            'RejectConsolidate',
            //RITM0577262
            this.state.inspectionModel.inspectionReport
          ) ? (
            <Button
              renderIcon={Error16}
              onClick={() =>
                this.batchActionClick('rejectconsolidatereport', 'Reject', null, false, true, null)
              }
            >
              Reject Report
            </Button>
          ) : null}
        </>
      </Online>
    );
  };

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    selectedRows
  ) {
    const idEntity = this.state.inspectionModel.idDivision;

    this.setState({
      approvalModalAction: actionName,
      isApprovalModalOpen: true,
      isLoadingApproverOptions: true,
      withApprover,
      selectedData: selectedRows,
      approverRole,
      approvalEndpoint: actionKey,
      approvalNotesRequired,
    });

    if (withApprover) this.getUsersInRole(approverRole, idEntity);
  }

  IsRowSelectable() {
    const inspectionItem = this.state.inspectionModel;
    if (
      inspectionItem == null ||
      inspectionItem.inspectionReport == null ||
      inspectionItem.inspectionReport.idStatus === STATUS.Consolidated
    ) {
      return false;
    }
    return true;
  }

  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
    const apiEndpoint = this.state.approvalEndpoint;

    const data = {
      ids: [this.state.inspectionModel.id],
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(`/inspection/${apiEndpoint}`, data, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.INSPECTION, apioperation.PUT));
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            tabsLoading: true,
          });

          // this.props.history.push('/');
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.INSPECTION, apioperation.PUT));
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {
        this.setState(
          {
            tabsLoading: false,
          },
          this.getInspectionEdit(this.state.inspectionkey.id)
        );
      });
  };

  getUsersInRole = (role, idEntity) => {
    me.getWithParam('users', {
      params: { Role: role, IdEntity: idEntity, includeAdmins: true },
    })
      .then((response) => {
        this.setState({
          approvers: response.data,
          isLoadingApproverOptions: false,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.ROLE, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingApproverOptions: false,
        });
      });
  };

  showButtonHistory = () => (
    <Button
      className="action-button-modal"
      kind="secondary"
      renderIcon={Information16}
      onClick={() => this.openModalHistory()}
    >
      History
    </Button>
  );

  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };

  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };

    render() {
    return this.state.inspectionModel ? (
      <AppContext.Consumer>
        {({ user }) => (IsEnabled(user, 'Inspection') ? this.renderTabs(user) : '')}
      </AppContext.Consumer>
    ) : (
      <></>
    );
  }
}
InspectionReport.contextType = AppContext;
